<template>
  <div class="flex md12 entreprise-infos">
    <div class="row">
      <div class="flex md6">
        <va-input
          v-model="entrepriseInfosMod.nom"
          placeholder="Nom entreprise"
          label="Nom"
          :error="validFirmName"
        />
      </div>
      <div class="flex md3">
        <va-input
          v-model="phoneNumber"
          placeholder="Telephone"
          label="Telephone"
          :error="validFPhone"
          v-on:paste="trimOnPaste('telephone')"
          v-on:focus="phoneNumber = removeWhiteSpace(phoneNumber)"
          v-on:blur="phoneNumber = formatPhoneNumber(phoneNumber)"
        />
      </div>
      <div class="flex md3">
        <va-input
          v-model="portableNumber"
          placeholder="Portable"
          label="Portable"
          :error="validPPhone"
          v-on:paste="trimOnPaste('portable')"
          v-on:focus="portableNumber = removeWhiteSpace(portableNumber)"
          v-on:blur="portableNumber = formatPhoneNumber(portableNumber)"
        />
      </div>
    </div>
    <div class="row">
      <div class="flex md6">
        <va-input
          v-model="entrepriseInfosMod.site_internet"
          placeholder="Site internet"
          label="Site internet"
        />
      </div>
      <div class="flex md6">
        <va-input
          v-model="entrepriseInfosMod.email"
          placeholder="Courriel"
          label="Courriel"
        />
      </div>
    </div>
    <div class="row">
      <div class="flex md2">
        <va-input
          v-model="inputSiret"
          placeholder="Siret siège"
          label="Siret siège"
          :error="validSiret"
          v-on:paste="trimOnPaste('siret')"
          v-on:focus="inputSiret = removeWhiteSpace(inputSiret)"
          v-on:blur="formatSiret()"
        />
      </div>
      <div class="flex md2">
        <va-select
          label="Code APE"
          v-model="selectApe"
          textBy="description"
          :options="apeOptions"
          no-clear
        />
      </div>
      <div class="flex md2">
        <va-input
          v-model="entrepriseInfosMod.nb_salaries"
          label="Nb employés siège"
          :error="validEmployeeNumber"
        />
      </div>
      <div class="flex md1">
        <va-button outline color="success" @click="openYearlyEmployees">
          <va-icon size="15px" name="fa fa-pencil" />
        </va-button>
      </div>
      <div class="flex md2">
        <va-select
          label="Forme juridique"
          v-model="selectFJ"
          textBy="description"
          :options="fjOptions"
          no-clear
        />
      </div>

      <div class="flex md3">
        <va-button class="fullwidth" :color="colorCCN" @click="openCCN">{{
          selectCCN.nom !== "-" ? selectCCN.nom : "Choisir la CCN"
        }}</va-button>
      </div>
    </div>
    <va-modal
      title="Nombres d'employés"
      class="modal-small modal"
      v-model="showNb"
      okText="Sauvegarder"
      v-on:ok="saveNbEmployees"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <va-input v-model="annees.n0" :label="refYear.toString()" />
        </div>
        <div class="flex md12">
          <va-input v-model="annees.n1" :label="(refYear - 1).toString()" />
        </div>
        <div class="flex md12">
          <va-input v-model="annees.n2" :label="(refYear - 2).toString()" />
        </div>
        <div class="flex md12">
          <va-input v-model="annees.n3" :label="(refYear - 3).toString()" />
        </div>
      </div>
    </va-modal>
    <va-modal
      title="Gestion de la CCN"
      max-width="100%"
      v-model="showCCN"
      okText="Sauvegarder"
      v-on:ok="saveCCN"
      v-on:cancel="cancelCCN"
    >
      <div class="modal-ccn">
        <div class="row row-inside">
          <div class="flex md12">
            <va-select
              label="CCN Appliquée"
              v-model="selectCCN"
              textBy="displayName"
              keyBy="idccn"
              :options="listeCCN"
              no-clear
            />
          </div>

          <div class="flex md12" v-if="selectCCN.idccn !== 1">
            <va-checkbox
              label="Considéré comme une poissonnerie"
              v-model="entrepriseInfosMod.ispoissonnerie"
            />
          </div>
          <div class="flex md12">
            <va-checkbox
              label="Inconnue base CAC"
              v-model="entrepriseInfosMod.inconnue_base_cac"
            />
          </div>
          <div class="flex md12 mt-3 text-bold" v-if="entrepriseInfos.userccn">
            Dernière modification:
          </div>
          <div class="flex md12" v-if="entrepriseInfos.userccn">
            {{ entrepriseInfos.userccn }} le
            {{
              moment(entrepriseInfos.dateccn, "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY"
              )
            }}
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { cloneDeep, isEqual, find } from "lodash";
import { isPhoneNumber } from "../../../services/utils";
import moment from "moment";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  props: ["entrepriseInfos"],

  data() {
    return {
      moment: moment,
      showCCN: false,
      refYear: moment().year(),
      annees: {
        n0: null,
        n1: null,
        n2: null,
        n3: null,
      },
      showNb: false,
      infosUpdated: false,
      entrepriseInfosMod: {
        identreprise: null,
        nom: null,
        siret: null,
        nb_salaries: null,
        code_ape: null,
        forme_juridique: null,
        nb_salaries: null,
        telephone: null,
        portable: null,
        email: null,
        site_internet: null,
        ispoissonnerie: false,
      },
      inputSiret: null,
      phoneNumber: null,
      portableNumber: null,
      selectApe: { id: 99, description: "-" },
      apeOptions: [
        { id: 0, description: "4723Z" },
        { id: 1, description: "4781Z" },
        { id: 2, description: "4638A" },
        { id: 3, description: "Autre" },
        { id: 4, description: "8559A" },
        { id: 99, description: "-" },
      ],
      selectFJ: { id: 99, description: "-" },
      fjOptions: [
        { id: 1, description: "EURL/SARL" },
        { id: 2, description: "SAS" },
        { id: 3, description: "SA" },
        { id: 4, description: "Entreprise Individuelle" },
        { id: 5, description: "CFA" },
        { id: 99, description: "-" },
      ],
      selectCCN: { idccn: 99, displayName: "-", nom: "-" },
      ccnBak: { idccn: 99, displayName: "-", nom: "-" },
    };
  },
  created() {
    // this.loadCCNList();
  },
  mounted() {},
  methods: {
    openCCN() {
      this.ccnBak = this.selectCCN;
      this.showCCN = true;
    },
    cancelCCN() {
      this.selectCCN = this.ccnBak;
    },
    saveCCN() {},
    async saveNbEmployees() {
      this.showNb = true;
      // todo secure the save
      let listNbs = [];
      if (this.annees.n0) {
        listNbs.push({
          identreprise: this.entrepriseInfos.identreprise,
          year: this.refYear,
          nb: parseInt(this.annees.n0),
        });
      }
      if (this.annees.n1) {
        listNbs.push({
          identreprise: this.entrepriseInfos.identreprise,
          year: this.refYear - 1,
          nb: parseInt(this.annees.n1),
        });
      }
      if (this.annees.n2) {
        listNbs.push({
          identreprise: this.entrepriseInfos.identreprise,
          year: this.refYear - 2,
          nb: parseInt(this.annees.n2),
        });
      }
      if (this.annees.n3) {
        listNbs.push({
          identreprise: this.entrepriseInfos.identreprise,
          year: this.refYear - 3,
          nb: parseInt(this.annees.n3),
        });
      }

      // push the modification
      // TODO deal with errors and check that numbers
      let params = {
        listNbs: listNbs,
      };
      try {
        await axios.put("/api/nb-employes", params);
        this.showNb = false;
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la sauvegarde");

        console.log(error);
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    async getListEmployes(identreprise) {
      let res = await axios.get("/api/nb-employes", {
        params: { identreprise: identreprise },
      });

      this.refYear = res.data.refYear;
      let refYear = this.refYear;
      if (res.data[refYear]) {
        this.annees.n0 = res.data[refYear].nb_employes;
      }

      if (res.data[refYear - 1]) {
        this.annees.n1 = res.data[refYear - 1].nb_employes;
      }
      if (res.data[refYear - 2]) {
        this.annees.n2 = res.data[refYear - 2].nb_employes;
      }
      if (res.data[refYear - 3]) {
        this.annees.n3 = res.data[refYear - 3].nb_employes;
      }
    },
    openYearlyEmployees() {
      if (this.entrepriseInfos.identreprise) {
        this.showNb = true;
        this.getListEmployes(this.entrepriseInfos.identreprise);
      }
    },
    // async loadCCNList() {
    //   let res = await axios.get("/api/ccns-list");
    //   this.ccnOptions = res.data;
    //   this.ccnOptions.splice(1, 0, { idccn: 99, displayName: "-" });
    //   // update select if needed
    //   this.selectCCN =
    //     this.selectCCN && this.selectCCN.idccn !== 99
    //       ? find(this.ccnOptions, { idccn: this.selectCCN.idccn })
    //       : this.selectCCN;
    // },
    trimOnPaste(entry) {
      if (entry == "siret") {
        setTimeout(() => {
          this.inputSiret = this.removeWhiteSpace(this.inputSiret);
        }, 200);
      }
      if (entry == "telephone") {
        setTimeout(() => {
          this.phoneNumber = this.removeWhiteSpace(this.phoneNumber);
        }, 200);
      }
      if (entry == "portable") {
        setTimeout(() => {
          this.portableNumber = this.removeWhiteSpace(this.portableNumber);
        }, 200);
      }
    },
    formatSiret() {
      if (!this.validSiret && this.inputSiret) {
        let siret = this.removeWhiteSpace(this.inputSiret);
        this.entrepriseInfosMod.siret = siret;

        // 3 3 3 puis 5

        this.inputSiret =
          siret.slice(0, 3) +
          " " +
          siret.slice(3, 6) +
          " " +
          siret.slice(6, 9) +
          " " +
          siret.slice(9, 14);
      }
    },
    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && (String(n) === str || n === str) && n >= 0;
    },
    formatPhoneNumber(str) {
      if (isPhoneNumber(str)) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    },
  },
  computed: {
    ...mapGetters(["listeCCN"]),
    colorCCN: function () {
      if (this.selectCCN.nom === "Poissonnerie") {
        return "success";
      }
      if (this.selectCCN.nom === "-") {
        return "gray";
      }

      return "info";
    },
    isFormValid: function () {
      if (
        this.validSiret ||
        this.validFPhone ||
        this.validPPhone ||
        this.validFirmName
      ) {
        return false;
      }
      return true;
    },
    validEmployeeNumber: function () {
      if (!this.entrepriseInfosMod.nb_salaries) return false;
      if (!this.isNormalInteger(this.entrepriseInfosMod.nb_salaries)) {
        return true;
      }
      return false;
    },
    validSiret: function () {
      if (!this.inputSiret) return false;
      let str = this.removeWhiteSpace(this.inputSiret);
      // no space
      //str = str.replace(/\s/g, "");
      // we do not fully validate the siret only length and integer
      let str0 = str.replace(/^[0]+/g, "");

      if (str.length === 14 && this.isNormalInteger(str0)) {
        return false;
      }
      return true;
    },
    validFPhone: function () {
      if (this.entrepriseInfosMod.telephone) {
        return !isPhoneNumber(this.entrepriseInfosMod.telephone);
      }
      return false;
    },
    validPPhone: function () {
      if (this.entrepriseInfosMod.portable) {
        return !isPhoneNumber(this.entrepriseInfosMod.portable);
      }
      return false;
    },
    validFirmName: function () {
      if (
        this.entrepriseInfosMod.nom &&
        this.entrepriseInfosMod.nom.length < 200
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    selectApe(newAPE) {
      this.entrepriseInfosMod.code_ape = newAPE.id !== 99 ? newAPE.id : null;
    },
    selectFJ(newFJ) {
      this.entrepriseInfosMod.forme_juridique =
        newFJ.id !== 99 ? newFJ.id : null;
    },
    selectCCN(newCCN) {
      // prevent "modification alert when not modified"
      this.entrepriseInfosMod.ccn =
        newCCN.idccn !== 99
          ? { idccn: newCCN.idccn, idcc: newCCN.idcc, nom: newCCN.nom }
          : null;
      this.entrepriseInfosMod.idccn = newCCN.idccn !== 99 ? newCCN.idccn : null;
    },
    inputSiret(newSiret) {
      this.entrepriseInfosMod.siret = this.removeWhiteSpace(this.inputSiret);
    },
    phoneNumber(newNumber) {
      this.entrepriseInfosMod.telephone = this.removeWhiteSpace(newNumber);
    },
    portableNumber(newNumber) {
      this.entrepriseInfosMod.portable = this.removeWhiteSpace(newNumber);
    },
    entrepriseInfosMod: {
      deep: true,
      handler() {
        if (!isEqual(this.entrepriseInfosMod, this.entrepriseInfos)) {
          this.$emit("infosChanged", true);
          this.infosUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infosUpdated = false;
        }
      },
    },
    entrepriseInfos(newEntreprise) {
      if (newEntreprise) {
        this.entrepriseInfosMod = cloneDeep(newEntreprise);

        this.selectApe =
          newEntreprise.code_ape || newEntreprise.code_ape === 0
            ? find(this.apeOptions, ["id", newEntreprise.code_ape])
            : find(this.apeOptions, ["id", 99]);
        this.selectFJ = newEntreprise.forme_juridique
          ? find(this.fjOptions, ["id", newEntreprise.forme_juridique])
          : find(this.fjOptions, ["id", 99]);
        this.selectCCN = newEntreprise.ccn
          ? find(this.listeCCN, { idccn: newEntreprise.idccn })
          : { idccn: 99, nom: "-", displayName: "-" };

        this.inputSiret = newEntreprise.siret ? newEntreprise.siret : null;
        this.formatSiret();
        this.phoneNumber = newEntreprise.telephone
          ? this.formatPhoneNumber(newEntreprise.telephone)
          : null;
        this.portableNumber = newEntreprise.portable
          ? this.formatPhoneNumber(newEntreprise.portable)
          : null;
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.entreprise-infos > * > .flex {
  padding-left: 0.25rem;
}

.modal-ccn {
  width: 40vw;
  height: 40vh;
}

.text-bold {
  font-weight: bold;
}
</style>
